<template>
    <base-modal :visible="visible" title="Create new Milestone" @close="$emit('close')">
        <base-backend-errors :data="create.error"/>
        <milestone-form :loading="create.loading" @submit="submit" @cancel="$emit('close')"/>
    </base-modal>
</template>

<script>
import { mapState } from 'vuex';
import MilestoneForm from './MilestoneForm.vue';

export default {
    name: 'MilestoneCreateModal',
    components: { MilestoneForm },
    props: ['space', 'visible'],
    computed: mapState('milestones', ['create']),
    methods: {
        async submit(data) {
            await this.$store.dispatch('milestones/create', {
                space_id: this.space.id,
                data,
            });

            // Redirect to first page if user is not in first page, otherwise reload milestones.
            if (this.$route.query.page && this.$route.query.page !== 1) {
                this.$router.push({ name: 'milestones', params: this.$route.params });
            } else {
                this.$store.dispatch('milestones/list', { space_id: this.space.id });
            }
            this.$emit('close');
        },
    },
};
</script>
